import { CustomerProfileDocumentsStatus, CustomersTableFields, CustomerStatus } from './enums'

export const customerTableHeaderTitles: Record<CustomersTableFields, string> = {
  [CustomersTableFields.logoUrl]: 'Logo',
  [CustomersTableFields.displayName]: 'Name',
  [CustomersTableFields.masterContractorOnboardedAt]: 'Onboarding',
  [CustomersTableFields.profileDocumentsStatus]: 'Profile documents',
  [CustomersTableFields.createdAt]: 'Date created',
}

export const customerStatusTitles: Record<CustomerStatus, string> = {
  [CustomerStatus.Active]: 'Active',
  [CustomerStatus.Deleted]: 'Inactive',
}

export const customerProfileDocumentsTitles: Record<CustomerProfileDocumentsStatus, string> = {
  [CustomerProfileDocumentsStatus.NotSubmitted]: 'Not submitted',
  [CustomerProfileDocumentsStatus.WaitingForApproval]: 'Waiting for approval',
  [CustomerProfileDocumentsStatus.Completed]: 'Complete',
  [CustomerProfileDocumentsStatus.Expired]: 'Expired',
  [CustomerProfileDocumentsStatus.Failed]: 'Failed',
}

// 500 and 1000 exceed the backend's current `limit` max of 100 (GetPartnerQuery `@Max(100)`)
// and will 400 until that cap is raised. Kept here anyway per product request.
export const customerPageSizeOptions = [25, 50, 100, 500, 1000]

export const CUSTOMERS_GRID_COLUMNS_STORAGE_KEY = 'admin.customers.gridColumns'
